import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-registration-dialog-box',
  templateUrl: './registration-dialog-box.component.html',
  styleUrls: ['./registration-dialog-box.component.scss']
})

export class RegistrationDialogBoxComponent implements OnInit {
  registrationForm: FormGroup;
  filteredListOfReg: { data: string }[];
  genderList: any;
  filteredGenderList: any;
  ConstiCateList: any;
  filteredConstiCateList: any;
  categoryList: any[];
  filteredCategoryList: any[];
  ListOfMedium: { data: string }[];
  filteredListOfMedium: { data: string }[];
  filteredNationalityList: any;
  nationalityList: any;
  ListOfGrid: any;
  filteredListOfGrid: any;
  EcIdd: any;
  dialogRef: MatDialogRef<any>;
  examList: any;
  show = false;
  ListOfReg;
  subjectList: any;
  filteredSubjectList: [];
  selectedSubjectList;
  submitbutton = true;
  updatebutton = false;
  Branches = false;
  Table = false;
  collegeList: [];
  filteredCollegeList: any;
  streamList: any;
  filteredStreamList: any;
  emid: any;
  stream: 0;
  SessionNo: any;
  ListOfExamSkipReason: any;
  filteredListOfExamSkipReason: any;
  courseClgMapList: any;
  minDate: Date;
  filteredstucourseClgMapListList: any;
  currentdate: Date;
  constructor(
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    public dialogRef2: MatDialogRef<RegistrationDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder
  ) {}
  ngOnInit(): void {
    this.minDate = new Date(1900, 0, 1);
    this.currentdate = new Date();
    this.Table = false;
    window.scroll(0,0)
    this.fetchSecretData();
    this.fetchListExamSkipReason();
    this.registrationForm = this.fb.group({
      CSExBr: new FormControl(""),
      EmSrNoF:new FormControl("1"),
      Code: new FormControl(""),
      Colg: new FormControl(""),
      valid: new FormControl(""),
      changed: new FormControl(""),
      Batch: new FormControl(""),
      Name: new FormControl('',Validators.required),
      RgNo: new FormControl(''),
      FormNo: new FormControl(""),
      CgCode: new FormControl('',Validators.required),
      Chng: new FormControl(""),
      Valid:new FormControl(""),
      Father: new FormControl(""),
      Mother: new FormControl(""),
      BirthDate: new FormControl('',Validators.required),
      Sex: new FormControl('M'),
      Cate: new FormControl('R'),
      Caste: new FormControl("OBC"),
      EMail: new FormControl(""),
      Medium: new FormControl('E'),
      Nation: new FormControl('1'),
      Mobile: new FormControl(""),
      Addr1: new FormControl(""),
      Addr2: new FormControl(""),
      Addr3: new FormControl(""),
      Addr1P: new FormControl(""),
      Addr2P: new FormControl(""),
      Addr3P: new FormControl(""),
      Pin: new FormControl(""),
      PinP: new FormControl(''),
      Place: new FormControl(''),
      StrCode: new FormControl(''),
      PlaceP: new FormControl(''),
      ExSub: new FormControl(''),
      Sub: new FormControl(''),
      EcId: new FormControl('',Validators.required),
      CgCodee: new FormControl(''),
      CoCode: new FormControl(''),
      SnNo: new FormControl(this.umsService.secretdata['SnNo']),
      msg:new FormControl(''),
      EmSkip:new FormControl('')
    });
    let i;
    // this.fetchList(i);
    this.getcollagelist();
    if (this.data.key == "New") {
      // this.prepopulation(this.data.selected);
      this.fetchListForGridAndLoad()
    } else if (this.data.key == "Delete") {
      // this.prepopulationForDelete(this.data.selected);
    } else {  
      // alert(this.data.key)
    }
  }

  fetchList(SnNo) {
    this.spinner.show();
    let payload = {};
    payload['SnNo'] = SnNo;
    payload['InCode'] = 51;
    payload['OpId'] = parseInt(sessionStorage.getItem('userId'));
    this.umsService.fetchRegiList(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ListOfReg = res.data;
        this.filteredListOfReg = this.ListOfReg.slice();
      } else {
      }
    });
  }

  getcollagelist(){
    this.spinner.show();
    let payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  selectedList(e){
    this.spinner.show();
    let payload2 = {};
    payload2['EmCoCode'] = e.CoCode;
    payload2['EmId'] = '';
    this.show = false;
    this.registrationForm.controls['CoCode'].setValue(e.CoCode);
    this.umsService.getExam(payload2).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.examList = res.data[0];
        this.fetchSubjects(this.examList)
      }else{
        this.examList = [];
      }
    });
    this.getCourse(e.CoCode);
    this.getCourseData(e.CoCode)
  }

  fetchSecretData() {
    this.spinner.show();
    this.umsService.getSecretData().subscribe((res) => {
      this.spinner.hide();
          // this.fetchSupExamRecord(res.projectPharam['SnNo']);
        this.SessionNo = res.projectPharam['SnNo'];
        this.fetchList(res.projectPharam['SnNo']);
      },
      (ERROR: HttpErrorResponse) => {
       
      }
    );
  }

  getCourse(e){
    this.spinner.show();
    let payload = {};
    payload['CoCode'] = e;
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe((res) => {
      this.spinner.hide();
      if(res.data.length > 0){
        this.Branches = true;
      }
      else{
        this.Branches = false;
      }
      if (res.status) {
        this.streamList = res.data;
        this.filteredStreamList = this.streamList.slice();
       
        
      }
      
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getSub(e){
    this.stream = e
    this.fetchSubjectStr(e,this.examList['EmId']);
  }

  fetchSubjectStr(Strid,EmID) {
    this.spinner.show();
    const payload = {};
    payload['EsEmId'] = EmID;
    payload['EsStrId'] = Strid;
    this.subjectList = [];    
    this.umsService.listofSubjects(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        let x = [];
        this.subjectList = res.data;
        this.filteredSubjectList = this.subjectList.slice();
        this.subjectList.forEach(element => {
        x.push(element.EsCode);
        });
      
        this.registrationForm.controls['Sub'].setValue(x);
      } else {
        this.subjectList = [];
        this.filteredSubjectList = this.subjectList.slice();
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }


  fetchListForGridAndLoad(){
    this.submitbutton = true;
    this.updatebutton = false;
    let tempEcId = this.registrationForm.value['EcId']
    if(this.registrationForm.controls['EcId'].valid){
      this.fetchListForGrid();
      this.registrationForm = this.fb.group({
        CSExBr: new FormControl(''),
        EmSrNoF:new FormControl("1"),
        Code: new FormControl(''),
        Colg: new FormControl(''),
        valid: new FormControl(''),
        changed: new FormControl(''),
        Batch: new FormControl(''),
        Name: new FormControl('',Validators.required),
        RgNo: new FormControl(''),
        FormNo: new FormControl(''),
        CgCode: new FormControl('',Validators.required),
        // Chng: new FormControl(''),
        // Valid:new FormControl(''),
        Father: new FormControl(''),
        Mother: new FormControl(''),
        BirthDate: new FormControl('',Validators.required),
        Sex: new FormControl('M'),
        Cate: new FormControl('R'),
        Caste: new FormControl("OBC"),
        EMail: new FormControl(""),
        Medium: new FormControl('E'),
        Nation: new FormControl('1'),
        Mobile: new FormControl(''),
        Addr1: new FormControl(''),
        Addr2: new FormControl(''),
        Addr3: new FormControl(''),
        Addr1P: new FormControl(''),
        Addr2P: new FormControl(''),
        Addr3P: new FormControl(''),
        Pin: new FormControl(''),
        PinP: new FormControl(''),
        Place: new FormControl(''),
        StrCode: new FormControl(''),
        PlaceP: new FormControl(''),
        ExSub: new FormControl(''),
        Sub: new FormControl(''),
        EcId: new FormControl(tempEcId,Validators.required),
        // CgCodee: new FormControl(''),
        CoCode: new FormControl(''),
        SnNo: new FormControl(this.umsService.secretdata['SnNo']),
        msg:new FormControl(''),
        EmSkip:new FormControl('')
      });
      this.show = true;
      this.getcollagelist();
    }else{
      this.registrationForm.get('EcId').markAsTouched();
    }
  }

  fetchListForGrid() {
    this.submitbutton = true;
    this.updatebutton = false;
    this.show = false;
    let payload = {};
    let formvalue = this.registrationForm.value
    if(this.registrationForm.controls['EcId'].valid){
      this.spinner.show();
      payload['EcId'] = formvalue['EcId']
      this.umsService.fetchRegiListForGrid(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.Table = true;
          this.ListOfGrid = res.data;
          this.filteredListOfGrid = this.ListOfGrid.slice();
        }else{
          this.Table = false;
          this.ListOfGrid = [];
          this.filteredListOfGrid = this.ListOfGrid.slice();
        }
      });
      this.fetchGender();
      this.fetchConstiCate();
      this.fetchCast();
      this.fetchListOfMedium();
      this.fetchNationality();
    }else{
      this.registrationForm.get('EcId').markAsTouched();
    }
   
  }

  fetchGender() {
    const payload = {};
    payload['CdType'] = 'SX';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.genderList = res.data;
        this.filteredGenderList = this.genderList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchConstiCate() {
    const payload = {};
    payload['CdType'] = 'CT';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.ConstiCateList = res.data;
        this.filteredConstiCateList = this.ConstiCateList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchCast() {
    const payload = {};
    this.categoryList = [];
    this.filteredCategoryList = [];
    payload['CdType'] = 'CS';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.categoryList = res.data;
        this.filteredCategoryList = this.categoryList.slice();
        //this.castGene(payload)
      } else {
      }
    });
  }

  fetchListOfMedium() {
    const payload = {};
    payload['CdType'] = 'ME';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfMedium = res.data;
        this.filteredListOfMedium = this.ListOfMedium.slice();
      } else {
      }
    });
  }
  fetchNationality() {
    const payload = {};
    payload['CdType'] = 'NA';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.nationalityList = res.data;
        this.filteredNationalityList = this.nationalityList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchSubjects(e) {
    const payload = {};
    payload['EsEmId'] = e.EmId;
    this.subjectList = [];    
    this.umsService.listofSubjects(payload).subscribe((res) => {
      if (res.status) {
        let x = [];
        this.subjectList = res.data;
        this.filteredSubjectList = this.subjectList.slice();
        this.subjectList.forEach(element => {
        x.push(element.EsCode);
        });
      
        this.registrationForm.controls['Sub'].setValue(x);
      } else {
        this.subjectList = [];
        this.filteredSubjectList = this.subjectList.slice();
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  addRegFormData() {
    if(this.registrationForm.invalid)
    {
      this.registrationForm.get('Name').markAsTouched();
      this.registrationForm.get('CgCode').markAsTouched();
      this.registrationForm.get('BirthDate').markAsTouched();   
    }else{
      this.spinner.show();
      let submitpayload = this.registrationForm.value;
      submitpayload['StrCode'] = parseInt(submitpayload['StrCode']);
      submitpayload['Sub'] = submitpayload['Sub'].toString();
      this.umsService.addRegiForm(submitpayload).subscribe(
        (res) => {

          this.validateAPI(res,submitpayload);
        },
        (ERROR: HttpErrorResponse) => {
          // this.stateList = [];
          this.spinner.hide();
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      );
    }
  }
  validateAPI(e,submitpayload){
    this.spinner.show();
    let payload = {};
    payload['EcId'] = submitpayload.EcId
    payload['Batch'] = e.message
    payload['Inst'] = parseInt(sessionStorage.getItem('Inst'))
    this.umsService.validateRegiForm(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.fetchListForGrid();
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      },
      (ERROR: HttpErrorResponse) => {
        // this.stateList = [];
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }
  editdata(e){
    this.registrationForm = this.fb.group({
      CSExBr: new FormControl(''),  
      Code: new FormControl(''),  
      Colg: new FormControl(''),  
      valid: new FormControl(e.Valid),  
      changed: new FormControl(''),  
      CgCodee: new FormControl(''), 
      Batch: new FormControl(e.Batch),
      Name: new FormControl(e.Name,Validators.required),
      RgNo: new FormControl(e.RgNo),
      FormNo: new FormControl(e.FormNo),
      CgCode: new FormControl(e.CgCode,Validators.required),
      Chng: new FormControl(e.Chng),  
      Valid:new FormControl(''),  
      Father: new FormControl(e.Father),
      Mother: new FormControl(e.Mother),
      BirthDate: new FormControl(new Date(e.BirthDate),Validators.required),
      Sex: new FormControl(e.Sex),
      Cate: new FormControl(e.Cate),
      Caste: new FormControl(e.Caste),
      EMail: new FormControl(e.EMail),  
      Medium: new FormControl(e.Medium),
      Nation: new FormControl(e.Nation),  
      Mobile: new FormControl(e.Mobile),  
      Addr1: new FormControl(e.Addr1),
      Addr2: new FormControl(e.Addr2),
      Addr3: new FormControl(e.Addr3),
      Addr1P: new FormControl(e.Addr1P),
      Addr2P: new FormControl(e.Addr2P),
      Addr3P: new FormControl(e.Addr3P),
      Pin: new FormControl(e.Pin),
      PinP: new FormControl(e.PinP),
      Place: new FormControl(e.Place),
      StrCode: new FormControl(e.StrCode),
      PlaceP: new FormControl(e.PlaceP),
      ExSub: new FormControl(e.ExSub), 
      Sub: new FormControl(e.Sub.split(",")), 
      EcId: new FormControl(e.EcId,Validators.required), 
      CoCode: new FormControl(e.CoCode),
      SnNo: new FormControl(e.SnNo),
      EmSrNoF: new FormControl(e.EmSrNoF),
      msg:new FormControl(e.Mesg),
      EmSkip:new FormControl('')
    });
    this.submitbutton = false;
    this.updatebutton = true;
    this.show = true;
  }
  update(){
    if(this.registrationForm.invalid)
    {
      this.registrationForm.get('Name').markAsTouched();
      this.registrationForm.get('CgCode').markAsTouched();
      this.registrationForm.get('BirthDate').markAsTouched();   
    }else{
      this.spinner.show();
      let submitpayload = this.registrationForm.value;
      submitpayload['Sub'] = submitpayload['Sub'].toString();
      submitpayload['StrCode'] = parseInt(submitpayload['StrCode']);
      this.umsService.updateRegiForm(submitpayload).subscribe(
        (res) => {
          this.validateAPI(res,submitpayload);
        },
        (ERROR: HttpErrorResponse) => {
          // this.stateList = [];
          this.spinner.hide();
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      );
    }
  }


  fetchListExamSkipReason() {
    const payload = {};
    payload['CdType'] = 'EMSK';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfExamSkipReason = res.data;
        this.filteredListOfExamSkipReason = this.ListOfExamSkipReason.slice();
      } else {
      }
    });
  }


  getCourseData(id) {
    this.spinner.show()
    const payload3 = {};
    payload3['CoCode'] = id;
    this.umsService.fetchstucourseClgMap(payload3).subscribe(res => {
      this.courseClgMapList = res.data;
      this.spinner.hide()
      this.filteredstucourseClgMapListList = this.courseClgMapList.slice();
      // this.dataSource = new MatTableDataSource(this.facultyList);
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.courseClgMapList = [];
      //this.spinner.hide();
      // let  data = {};
      // data['message'] = ERROR.error.message;
      // data['title'] = 'Information';
      // data['icon'] = 'fas fa-box-open';
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.umsService.openSnackbar(ERROR.error.message);
   });

  }
}